<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const hour = ref('')
  const date = ref('')
  const router = useRouter()
  const pluginStore = usePlugin()

  onMounted(() => {
    modal.value = new Modal('#modal-download-certificate', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    if (pluginStore.issuedAt.trim().length === 0) {
      modal.value?.show()
      return
    }

    const [dateTimeDate = '', dateTimeHour = ''] =
      pluginStore.issuedAt.split(' ')
    date.value = dateTimeDate.split('-').reverse().join('/')
    hour.value = dateTimeHour

    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function downloadCertificate() {
    setTimeout(() => {
      router.push({
        path: '/issue/plugin/success',
      })
    }, 500)
    hide()
  }

  defineExpose({
    show,
    hide,
  })
</script>

<template>
  <div
    id="modal-download-certificate"
    class="modal modal-md fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Certificado emitido!</h5>
        </div>
        <div class="modal-body py-3">
          <img alt="sucesso" src="../assets/success-girl.svg" />

          <p class="fs-6 text-start mt-5">
            Agora é só <strong>baixar o Certificado</strong> no seu computador!
          </p>

          <div
            v-if="date.trim().length > 0 && hour.trim().length > 0"
            class="time-card my-4 d-flex flex-column p-3"
          >
            <div class="text-start d-flex flex-row justify-content-start w-100">
              Data da emissão: <strong class="ms-2">{{ date }}</strong>
            </div>
            <div class="text-start d-flex flex-row justify-content-start w-100">
              Hora da emissão: <strong class="ms-2">{{ hour }}</strong>
            </div>
          </div>

          <div id="faqAccordionWhereToStoreCertificate" class="accordion mt-4">
            <div class="accordion-item">
              <div
                id="faqAccordionQuestionWhereToStoreCertificate"
                class="accordion-header"
              >
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faqAccordionAnswerWhereToStoreCertificate"
                  aria-expanded="false"
                  aria-controls="faqAccordionAnswerWhereToStoreCertificate"
                >
                  Como definir o local ideal para armazenar seu Certificado
                  Digital?
                </button>
              </div>
              <div
                id="faqAccordionAnswerWhereToStoreCertificate"
                class="accordion-collapse collapse"
                aria-labelledby="faqAccordionQuestionWhereToStoreCertificate"
                data-bs-parent="#faqAccordionWhereToStoreCertificate"
              >
                <div class="accordion-body">
                  <p class="text-start fs-6 m-0">
                    <strong
                      >Defina um local seguro e de fácil memorização</strong
                    >
                    para acessar o Certificado.
                    <br />
                    <br />
                    <strong>Ajuste as preferências do seu navegador</strong>, na
                    seção <strong>”Downloads”</strong>, para escolher a pasta de
                    armazenamento dos arquivos baixados.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer py-3">
          <a
            class="btn btn-primary"
            :href="pluginStore.csrDownloadLink"
            target="_blank"
            @click="() => downloadCertificate()"
          >
            <icon-component name="download" class="me-2" />
            Baixar Certificado e fechar
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .btn:focus {
    color: white;
  }

  .time-card {
    background-color: #ffffff;
    border: 1px solid #a7a9b6;
    border-radius: 10px;
  }

  .accordion-button {
    background: var(--color-grayscale-light) !important;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
